module.exports = __webpack_public_path__ + "img/reason19.5d47eed6.png";